<script setup lang="ts">
import { $patchStyleText } from "@lexical/selection";
import { mergeRegister } from "@lexical/utils";
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_LOW } from "lexical";
import { useLexicalComposer } from "lexical-vue";
import { onMounted, onUnmounted } from "vue";

import { EVENT_FORMAT_BACKGROUND_COLOR, EVENT_FORMAT_TEXT_COLOR } from "../const";

const editor = useLexicalComposer();

const applyStyle = (style: Record<string, string>) =>
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }
    $patchStyleText(selection, style);
  });

const onTextColorChange = (color: string) => {
  applyStyle({ color });
  return true;
};

const onBgColorChange = (color: string) => {
  applyStyle({ "background-color": color });
  return true;
};

let unregisterListeners: () => void;

onMounted(() => {
  unregisterListeners = mergeRegister(
    editor.registerCommand(EVENT_FORMAT_TEXT_COLOR, onTextColorChange, COMMAND_PRIORITY_LOW),
    editor.registerCommand(EVENT_FORMAT_BACKGROUND_COLOR, onBgColorChange, COMMAND_PRIORITY_LOW)
  );
});

onUnmounted(() => {
  unregisterListeners?.();
});
</script>

<template>
  <slot />
</template>
